;(function () {
  'use strict'

  angular
    .module('contrast.virtual-patch')
    .controller(
      'PrePopVirtualPatchCtrl',
      function PrePopVirtualPatchCtrl(
        $location,
        $controller,
        $scope,
        $routeParams,
        UserService,
        virtualPatchService
      ) {
        'ngInject'

        var vm = this
        var baseCtrl

        this.$onInit = function () {
          vm = this
          baseCtrl = $controller('BaseVirtualPatchCtrl', {
            $scope: $scope
          })
          baseCtrl.$onInit()

          angular.extend(vm, baseCtrl)
          angular.extend($scope, {
            savePatch: savePatch
          })

          init()
        }

        function init() {
          $scope.pre_populated = true
          _loadPatch()
            .then(baseCtrl.init)
            .then(function () {
              if (!$scope.patch.applications) {
                $scope.patch.apps = []
              } else {
                $scope.patch.apps = _.map($scope.patch.applications, 'app_id')
              }
            })
        }

        function _loadPatch() {
          return virtualPatchService
            .prepopVirtualPatch($routeParams.eventId)
            .then(function (patch) {
              $scope.patch = patch
              $scope.patch.applyTo = virtualPatchService.getApplyTo(
                patch.application_mode
              )
            })
        }

        function savePatch() {
          var patchSettings = virtualPatchService.transformPatchSettings(
            $scope.patch
          )

          return virtualPatchService
            .addVirtualPatch(patchSettings)
            .then(function () {
              $location.path(UserService.buildUrl('/rules/patches'))
            })
        }

        this.$onInit()
      }
    )
})()
